export default "__VITE_ASSET__2aaacc58__"